import { INLINE_FILTERS_KEYS } from 'features/command-center/constants';
import { filtersToParams } from 'selectors/app';
import { FilterType } from 'UI/constants/defaults';
import { UIStatus } from 'UI/constants/status';
import { getTodayDate, loadFromLocalStorage } from 'UI/utils';

import { renderMultipleTags } from '../shared/InlineFilters/InlineFilters.constants';

export const getSavedYearFilter = () => {
  const filters = loadFromLocalStorage(
    `inline-filters-${INLINE_FILTERS_KEYS.financial.commissionsBoard}`
  );
  return filters?.years?.value?.title ?? null;
};

export const getExtraFilters = ({ yearsOptions, payPeriodsState, currentYear }) => {
  const years = yearsOptions.map(year => ({
    id: year,
    title: year.toString()
  }));

  const payPeriodOptions =
    payPeriodsState?.results?.map(item => ({
      ...item,
      title: item.startDate
    })) || [];

  return [
    {
      name: 'years',
      paramName: 'year',
      title: 'Year',
      type: FilterType.Autocomplete,
      getOptionLabel: ({ title }) => title,
      defaultValue: { id: currentYear, title: currentYear },
      options: years
    },
    {
      name: 'payPeriods',
      title: 'Pay Periods',
      paramName: 'periodIds',
      idKey: 'id',
      type: FilterType.Autocomplete,
      fetching: payPeriodsState?.status === UIStatus.Loading,
      getOptionLabel: ({ title }) => title,
      getOptionSelected: (option, value) => option.id === value?.id,
      multiple: true,
      options: payPeriodOptions,
      disableListWrap: true,
      renderTags: selected => renderMultipleTags(selected, 'startDate')
    }
  ];
};

export const getMonthParam = (years, months) => {
  const [currentYear, currentMonth] = getTodayDate().split('-');
  const year = years?.value?.id ?? currentYear;
  const month = months?.value?.extendedId ?? currentMonth;

  return `${year}-${month}-01`;
};

export const formatFallOffsBoardFilters = (filters = {}) => {
  const { years, months, ...rest } = filters;

  return { ...filtersToParams(rest), month: getMonthParam(years, months) };
};

export const updatePeriodIds = (queryParams, newPeriodIds) => {
  if (!newPeriodIds) return queryParams;

  const params = new URLSearchParams(queryParams);
  params.set('periodIds', newPeriodIds);
  return params.toString();
};
